<ion-app id="ion-app">
    <!-- Incoming call notification bar -->
    <app-incoming-call-notification></app-incoming-call-notification>
    
    <!-- <ion-router-outlet id="main-content" [swipeGesture]="false"></ion-router-outlet> -->
    <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>